import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import { sectionContainer } from './scss/SectionContainer.module.scss';

const SectionContainer = ({ children, name, className }) => (
  <section name={name} className={classNames(sectionContainer, className)}>
    {children}
  </section>
);

SectionContainer.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  name: PropTypes.string,
};

SectionContainer.defaultProps = {
  children: null,
  className: '',
  name: '',
};

export default SectionContainer;
